import React from 'react';

import { Form, Input } from 'antd';

export const EmailLoginField = (props) => {
  const { email, setEmail } = props;

  const form = Form.useFormInstance();

  const handleSetEmail = (value) => {
    setEmail(value?.trim());
    form?.setFieldValue('email', value?.trim());
  };
  return (
    <Form.Item validateTrigger='onBlur' name='email'>
      <Input id='email' value={email} onChange={(e) => handleSetEmail(e.target.value)} />
    </Form.Item>
  );
};
